import { render } from "./Chart.vue?vue&type=template&id=ad80a6b6"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"

import "./Chart.vue?vue&type=style&index=0&id=ad80a6b6&lang=scss"
script.render = render

export default script